import { Navigate } from 'react-router-dom';
import { useWorker } from '../context/WorkerContext';

const ProtectedRoute = ({ children }) => {
  const { user, initialized } = useWorker();

  if (!initialized) {
    return null;
  }

  if (!user) {
    return <Navigate to="/lkart/" replace />;
  }

  return children;
};

export default ProtectedRoute;